<template>
  <QDrawer
    v-model="configStore.leftDrawerOpen"
    no-swipe-open
    no-swipe-close
    no-swipe-backdrop
    :width="250"
    :behavior="$q.screen.lt.md?'mobile':'desktop'"
    class="left-drawer"
  >
    <div
      v-if="$q.screen.lt.md"
      class="h-16 flex flex-nowrap items-center gap-2 items-center p-2 w-full"
    >
      <div class="flex items-center justify-center rounded dark:bg-dark-1 light:bg-light-3">
        <QBtn
          flat
          dense
          icon="menu"
          aria-label="Menu"
          class="h-10 w-10"
          @click="configStore.toggleLeftDrawer()"
        />
      </div>
      <Logo
        class="w-25"
        clickable
        :dark="$q.dark.isActive"
      />
    </div>
    <QScrollArea class="h-full">
      <div class="pb-4 flex flex-col px-2">
        <MenuNav
          v-if="$q.screen.lt.md"
          class="mt-2"
        />
        <PopularLeague />
        <SportNav />
      </div>
    </QScrollArea>
  </QDrawer>
</template>

<script setup>
import { useConfigStore } from '@/stores/config.js'
import { whenever } from '@vueuse/core'
import { useQuasar } from 'quasar'
import Logo from '@/components/Logo.vue'
import MenuNav from './MenuNav.vue'
import SportNav from './SportNav.vue'
import PopularLeague from './PopularLeague.vue'

const $q = useQuasar()
const configStore = useConfigStore()

whenever(() => $q.screen.lt.md, () => {
  configStore.leftDrawerOpen = false
}, { immediate: true })
whenever(() => $q.screen.gt.md, () => {
  configStore.leftDrawerOpen = true
}, { immediate: true })
</script>
